const uzCyrl = {
    common: {
        save: 'Сақлаш',
        cancel: 'Бекор қилиш',
        add: 'Қўшиш',
        new: 'Янги',
        edit: 'Таҳрирлаш',
        delete: 'Ўчириш',
        search: 'Қидириш...',
        actions: 'Ҳаракат',
        loading: 'Юкланмоқда...',
        confirm: 'Тасдиқлаш',
        close: 'Ёпиш',
        back: 'Орқага',
        all: 'Ҳаммаси',
        none: 'Йўқ',
        today: 'Бугун',
        date: 'Сана',
        phone: 'Телефон',
        name: 'Ф.И.Ш.',
        status: 'Ҳолат',
        address: 'Манзил',
        doctor: 'Шифокор',
        patient: 'Бемор',
        amount: 'Сумма',
        details: 'Батафсил',
        print: 'Чоп этиш',
        accept: 'Қабул қилиш',
        reject: 'Рад этиш',
        filter: 'Филтр',
        year: 'Йил',
        province: 'Вилоят',
        district: 'Туман',
        clear: 'Тозалаш',
        yes: 'Ҳа',
        no: 'Йўқ',
        id: 'ID',
        code: 'Код',
        card: 'Карта',
        profile: 'Профил',
        logout: 'Тизимдан чиқиш',
        settings: 'Созламалар',
        language: 'Тил',
        login: 'Логин',
        password: 'Пароль',
        rememberMe: 'Мени эслаб қолиш',
        signIn: 'Кириш',
        saved: 'Сақланди',
        total: 'Жами',
        count: 'Сони',
        remark: 'Изоҳ',
        type: 'Тур',
        price: 'Нарх',
        empty: 'Маълумот йўқ',
        more: 'Яна',
        select: 'Танлаш',
        required: 'Мажбурий майдон',
        success: 'Муваффақиятли',
        error: 'Хатолик',
        openMenu: 'Менюни очиш',
        collapseSidebar: 'Панелни йиғиш',
        expandSidebar: 'Панелни кенгайтириш',
        dentalClinic: 'Стоматология бошқаруви',
        perPage: '{{from}}–{{to}} / {{total}}',
        dash: '—',
        service: 'Хизмат',
        searchName: 'Ф.И.Ш. киритинг',
        createdAt: 'Яратилган сана',
        currency: 'сўм',
        uzs: 'UZS',
        show: 'Кўрсатиш',
        exportExcel: 'Excelга экспорт',
        searchBy: '{{field}} бўйича қидириш',
        reset: 'Тозалаш',
        noExport: 'Экспорт учун маълумот йўқ',
        loadError: 'Маълумот юкланмади',
        pageOf: 'Саҳифа {{current}}/{{total}}',
        prev: 'Олдинги',
        next: 'Кейингиси',
        category: 'Категория',
        qty: 'Миқдор',
        view: 'Кўриш',
        sender: 'Юборувчи',
        receiver: 'Қабул қилувчи',
        noComment: 'Изоҳ йўқ',
        unknown: 'Номаълум',
        update: 'Янгилаш',
        submit: 'Юбориш',
        create: 'Яратиш',
        identifier: 'Идентификатор',
        visitDay: 'Қабул куни',
        pieces: '{{count}} та',
        clinicName: 'Тиббиёт клиникаси',
        email: 'Email',
        active: 'Фаол',
        workPlace: 'Иш жойи',
        notEntered: 'Киритилмаган',
    },
    nav: {
        main: 'Асосий',
        home: 'Бош саҳифа',
        patients: 'Беморлар',
        callCenter: 'Колл марказ',
        sms: 'СМС хабарнома',
        catalog: 'Каталог',
        doctors: 'Шифокорлар',
        discounts: 'Чегирмалар',
        smsTemplates: 'СМС шаблонлар',
        services: 'Хизматлар',
        epidem: 'Эпидемиологик тарих',
        mkb10: 'ХКТ-10',
        partners: 'Ҳамкорлар',
        finance: 'Молия',
        cash: 'Касса',
        debtors: 'Қарздорлар рўйхати',
        payments: 'Тўловлар тарихи',
        appointments: 'Қабуллар',
        allAppointments: 'Барча қабуллар',
        queue: 'Навбатда',
        reappointments: 'Қайта навбатлар',
        followups: 'Қайта қабуллар',
        recall: 'Қайта қўнғироқлар',
        patientActivity: 'Мижозлар фаоллиги',
        additionalServices: 'Қўшимча хизматлар',
        analytics: 'Аналитика',
        reports: 'Ҳисоботлар',
        reportsPatients: 'Беморлар бўйича',
        reportsDoctors: 'Шифокорлар бўйича',
        reportsFinance: 'Маблағлар бўйича',
        reportsPartners: 'Ҳамкорлар бўйича',
        inventory: 'Омбор',
        storeProducts: 'Омбор маҳсулотлари',
        categories: 'Категориялар',
        warehouse: 'Омбор',
        requests: 'Буюртмалар',
        resendRequests: 'Қайтарилган буюртмалар',
        doctorVisits: 'Шифокор қабуллари',
        doctorRequest: 'Буюртма',
        technicianLab: 'Лаборатория',
        technicianObjects: 'Техник объектлари',
        technicianRequests: 'Техникка буюртмалар',
        settings: 'Созламалар',
        roles: 'Роллар',
        users: 'Фойдаланувчилар',
    },
    status: {
        queue: 'Навбатда',
        examined: 'Қабулда',
        new: 'Янги қабул',
        pending: 'Тўлов кутилмоқда',
        payed: 'Тўланган',
        revisit: 'Навбатда',
        closed: 'Ёпилган',
        inactive: 'Фаол эмас',
        planned: 'Режалаштирилган',
        completed: 'Бажарилган',
        canceled: 'Бекор қилинган',
        process: 'Жараёнда',
        accept: 'Қабул қилинди',
        cancel: 'Рад этилди',
        inBase: 'Бор',
        notInBase: 'Йўқ',
        primary: 'Асосий',
        extra: 'Қўшимча',
        all: 'Ҳаммаси',
        ambulatory: 'Амбулатор',
        stationary: 'Стационар',
    },
    login: {
        loading: 'Юкланмоқда...',
        success: 'Тизимга муваффақиятли кирдингиз',
        error: 'Кириш маълумотлари нотўғри',
        logoAlt: 'Логотип',
        videoFallback: 'Браузерингиз видеони қўллаб-қувватламайди',
        welcome: 'Хуш келибсиз',
        subtitle: 'Давом этиш учун тизимга киринг',
        panelText: 'Календар, беморлар ва қабуллар — битта жойда',
        signingIn: 'Кирилмоқда...',
    },
    settings: {
        title: 'Созламалар',
        subtitle: 'Интерфейс тили ва платформа параметрлари',
        languageTitle: 'Интерфейс тили',
        languageHint: 'Танланган тил шу қурилмада сақланади ва бутун платформага дарҳол қўлланади.',
        applied: 'Тил ўзгартирилди',
        ru: 'Русча',
        uzLatn: 'Ўзбекча (лотин)',
        uzCyrl: 'Ўзбекча (кирилл)',
        current: 'Жорий тил',
    },
    patients: {
        title: 'Беморлар',
        new: 'Янги',
        search: 'Қидириш...',
        birthDate: 'Туғилган сана',
        card: 'Карта',
        edit: 'Таҳрирлаш',
        created: 'Бемор яратилди',
        updated: 'Бемор янгиланди',
        saveError: 'Сақлашда хатолик',
        colId: '№',
        colName: 'Ф.И.Ш.',
        colBirth: 'Туғилган сана',
        colStatus: 'Ҳолат',
        colAddress: 'Манзил',
        colPhone: 'Телефон',
        colActions: 'Ҳаракат',
        formCreate: 'Янги бемор',
        formEdit: 'Таҳрирлаш ⟶ {{name}}',
        formName: 'Бемор Ф.И.Ш.',
        formNameReq: 'Бемор Ф.И.Ш.ини киритинг',
        formAddress: 'Яшаш манзили',
        formAddressReq: 'Яшаш манзилини киритинг',
        formPartner: 'Ҳамкор',
        formPartnerReq: 'Ҳамкорни танланг',
        formPhone: 'Телефон рақами',
        formPhoneReq: 'Телефон рақамини киритинг',
        formPhoneHint: 'Код билан тўғри телефон рақамини киритинг',
        formProfession: 'Касби',
        formBirth: 'Туғилган куни',
        formBirthReq: 'Туғилган кунини танланг',
        formHome: 'Уй манзили',
        formHomeReq: 'Уй манзилини киритинг',
        formWork: 'Иш манзили',
        formRemark: 'Изоҳ',
        formGender: 'Жинси',
        formGenderReq: 'Жинсини танланг',
        formPhoto: 'Расм',
        formUpload: 'Файл юклаш',
        formUploadHint: 'Файлни шу ерга ташланг ёки юклаш учун босинг',
        formSubmit: 'Беморни сақлаш',
        formSubmitAdd: 'Бемор қўшиш',
    },
    doctors: {
        title: 'Шифокорлар',
        add: 'Қўшиш',
        edit: 'Шифокорни таҳрирлаш',
        create: 'Янги шифокор',
        delete: 'Ўчириш',
        colPhone: 'Телефон',
        colRole: 'Рол',
        fio: 'Ф.И.Ш.',
        login: 'Логин',
        password: 'Пароль',
        passwordRepeat: 'Паролни такрорланг',
        phone: 'Телефон рақами',
        created: 'Шифокор яратилди',
        updated: 'Шифокор янгиланди',
        deleted: 'Шифокор ўчирилди',
        nameRequired: 'Ф.И.Ш. майдонини тўлдиринг',
        loginRequired: 'Логин майдонини тўлдиринг',
        passwordRequired: 'Парол майдонини тўлдиринг',
        passwordMismatch: 'Пароллар бир хил бўлиши керак',
        confirmPasswordRequired: 'Паролни такрорланг',
        phoneRequired: 'Телефон рақамини тўлдиринг',
        phoneTaken: 'Бу телефон рақами аллақачон рўйхатдан ўтган',
    },
    services: {
        title: 'Асосий хизматлар',
        add: 'Қўшиш',
        edit: 'Хизматни таҳрирлаш',
        create: 'Хизмат қўшиш',
        name: 'Хизмат номи',
        price: 'Нархи',
        kind: 'Тур',
        serviceType: 'Хизмат тури',
        search: 'Хизматни қидириш',
        cancel: 'Бекор қилиш',
        save: 'Сақлаш',
    },
    partners: {
        title: 'Барча ҳамкорлар',
        add: 'Қўшиш',
        create: 'Ҳамкор қўшиш',
        edit: 'Ҳамкорни таҳрирлаш',
        delete: 'Ҳамкорни ўчириш',
        phone: 'Телефон рақами',
        created: 'Ҳамкор қўшилди',
        updated: 'Ҳамкор янгиланди',
        deleted: 'Ҳамкор ўчирилди',
        saveError: 'Ҳамкорни сақлаб бўлмади',
        deleteError: 'Ҳамкорни ўчириб бўлмади',
    },
    discounts: {
        title: 'Мавжуд чегирмалар',
        create: 'Янги чегирма қўшиш',
        name: 'Чегирма номи',
        percent: 'Чегирма (%)',
        startDate: 'Бошланиш санаси',
        endDate: 'Тугатиш санаси',
        submit: 'Яратиш',
        namePlaceholder: 'Акция номини киритинг',
        created: 'Янги акция муваффақиятли яратилди',
        createError: 'Акция яратишда хатолик юз берди',
    },
    sms: {
        title: 'СМС юбориш',
        templates: 'Хабар шаблонлари',
        addTemplate: 'Шаблон қўшиш',
        editTemplate: 'Шаблонни таҳрирлаш',
        send: 'СМС юбориш',
        searchPatient: 'Беморни қидириш...',
        birthdayToday: 'Бугун туғилганларни кўрсатиш',
        showAll: 'Барчасини кўрсатиш',
        selectWarning: 'Беморлар ва шаблонни танланг',
        sent: 'СМС юборилди',
        sendError: 'СМС юборилмади',
        loadPatientsError: 'Беморлар юкланмади',
        loadTemplatesError: 'Шаблонлар юкланмади',
    },
    smsTemplates: {
        title: 'Хабар шаблонлари',
        legalEntity: 'Юр. шахс',
        inn: 'СТИР',
        senderName: 'Юборувчи номи',
        templateType: 'Шаблон тури',
        text: 'Матн',
        service: 'Сервис',
        transaction: 'Транзакция',
        loadError: 'Шаблонлар юкланмади',
        created: 'Шаблон яратилди',
        updated: 'Шаблон янгиланди',
        deleted: 'Шаблон ўчирилди',
        saveError: 'Шаблон сақланмади',
        deleteError: 'Шаблон ўчирилмади',
    },
    epidem: {
        title: 'Эпидемиологик тарих',
        edit: 'Ёзувни таҳрирлаш',
        create: 'Ёзув қўшиш',
        name: 'Номи',
    },
    mkb10: {
        title: 'ХКТ-10',
        additionalInfo: 'Қўшимча маълумот',
    },
    payments: {
        title: 'Тўловлар тарихи',
        date: 'Тўлов санаси',
        serviceNumber: 'Хизмат рақами',
        total: 'Умумий миқдор',
        paid: 'Тўланган',
        left: 'Қолган',
        search: 'Қидириш...',
        searchBtn: 'Излаш',
        serviceName: 'Хизмат номи',
        serviceCount: 'Хизмат сони',
        txAmount: 'Транзакция миқдори',
        txType: 'Транзакция тури',
        txDate: 'Транзакция санаси',
        cash: 'Нақд пул',
        card: 'Карта',
        bank: 'Банк ўтказмаси',
        online: 'Онлайн тўлов',
        credit: 'Қарзга',
        creditCard: 'Кредит карта',
        enterAmount: 'Тўлов суммасини киритинг',
        pay: 'Тўлаш',
        paymentMethod: 'Тўлов усули',
        paymentStatus: 'Тўлов ҳолати',
        remaining: 'Қолган сумма',
        selectedOrder: 'Танланган буюртма',
        noOrders: 'Тўлов учун буюртма йўқ',
        payError: 'Тўловни амалга оширишда хатолик',
        paySuccess: 'Тўлов бажарилди: {{id}}',
        paidLabel: 'Тўланди: {{id}}',
        receiptNo: 'Чек №',
        thankYou: 'Харидингиз учун раҳмат!',
        stayHealthy: 'Соғ бўлинг! Клиникамизга ташриф буюрганингиз учун ташаккур.',
        noDiscount: 'Чегирма йўқ',
        discount: 'Чегирма (%)',
        debit: 'Дебет',
        totalPaid: 'Жами тўланган',
        finish: 'Тугатиш',
        invoice: 'Ҳисоб-фактура',
        enterPayment: 'Тўлов киритиш',
        receipt: 'Чек',
        visitNumber: 'Ташриф рақами: {{id}}',
        payTitle: 'Тўлаш — {{id}}',
        paymentSlip: 'Тўлов квитанцияси',
        mainService: 'Асосий хизмат',
        noServiceData: 'Хизматлар ҳақида маълумот йўқ',
        noOrderData: 'Буюртма ҳақида маълумот йўқ',
        paymentAmount: 'Тўлов суммаси',
    },
    debtors: {
        title: 'Қарздорлар рўйхати',
        pay: 'Тўлаш',
        orderId: 'Буюртма ID',
        transaction: 'Транзакция',
        debt: 'Қарз',
    },
    admissions: {
        queue: 'Навбатлар',
        reappointments: 'Қайта навбатлар',
        followups: 'Қайта қабуллар',
        recall: 'Қайта қўнғироқлар',
        dispensary: 'Диспансер ҳисоби',
        paymentReceipt: 'Тўлов → чек',
        paymentInfo: 'Тўлов маълумоти',
        printReceipt: 'Чек чиқариш',
        callResult: 'Қўнғироқ натижаси',
        addToQueue: 'Қабулга қўшиш',
        revisitDate: 'Қайта қабул санаси',
        visitCreated: '{{name}} бемори учун ташриф яратилди',
        visitCreateError: 'Ташриф яратишда хатолик',
        visitId: 'Ташриф ID',
        noServices: 'Хизмат йўқ',
        payment: 'Тўлов',
        remaining: 'Қолган сумма',
    },
    reports: {
        patients: 'Беморлар бўйича ҳисобот',
        doctors: 'Шифокорлар бўйича ҳисобот',
        finance: 'Маблағлар бўйича ҳисобот',
        financeDate: 'Шифокорнинг маблағ ҳисоботи {{date}}',
        partners: 'Ҳамкорлар бўйича таҳлил',
        partnersShare: 'Ҳамкорлар улуши',
        doctorDetail: 'Шифокорнинг батафсил ҳисоботи',
        info: 'Маълумот',
        show: 'Кўрсатиш',
        exportExcel: 'Excelга экспорт',
        doctorName: 'Шифокор Ф.И.Ш.',
        patientsSeen: 'Кўрилган беморлар',
        patientsCount: 'Келган беморлар сони',
        totalAmount: 'Жами сумма',
        partner: 'Ҳамкор',
        todayCame: 'Бугун келди',
        newPatients: 'Янги беморлар',
        repeatPatients: 'Қайта беморлар',
        share: 'Улуш (%)',
        allPartners: 'Барча ҳамкорлар',
        patientName: 'Бемор исми',
        noExport: 'Экспорт учун маълумот йўқ',
        loadError: 'Маълумот юкланмади',
        badFormat: 'API маълумот формати нотўғри',
        search: 'Қидириш',
        reset: 'Тозалаш',
        searchBy: '{{field}} бўйича қидириш',
    },
    store: {
        categories: 'Барча категориялар',
        addCategory: 'Категория қўшиш',
        editCategory: 'Категорияни таҳрирлаш',
        warehouse: 'Омбор маҳсулот',
        history: 'Тарих',
        add: 'Қўшиш',
        edit: 'Таҳрирлаш',
        requests: 'Буюртмалар',
        resend: 'Қайтарилган буюртмалар',
        accept: 'Қабул қилиш',
        reject: 'Рад этиш',
        details: 'Батафсил',
        fullRemark: 'Тўлиқ изоҳ',
        doctorRequests: 'Буюртмалар',
        returnGoods: 'Товарни қайтариш',
        newRequest: 'Янги буюртма',
        name: 'Номи',
        addNew: 'Янги қўшиш',
        namePh: 'номи',
        update: 'Янгилаш',
        deleted: 'Категория ўчирилди',
        deleteError: 'Ўчиришда хатолик',
        added: 'Категория қўшилди',
        updated: 'Категория янгиланди',
        saveError: 'Сақлашда хатолик',
        grandTotal: 'Умумий',
        requestHistory: 'Сўровнома тарихи',
        sender: 'Юборувчи',
        receiver: 'Қабул қилувчи',
        notReceived: 'Қабул қилинмаган',
        noRemark: 'Изоҳ йўқ',
        historyQty: 'Тарихи (Миқдор: {{qty}})',
        nameFilter: 'номини киритинг...',
        pickCategory: 'Категорияни танланг',
        excelExport: 'Excel экспорт',
        exportOk: 'Экспорт муваффақиятли',
        exportError: 'Экспортда хатолик юз берди',
        fillFields: 'Барча майдонларни тўлдиринг',
        loadError: 'Маълумот юкланмади',
        productUpdated: 'Маҳсулот муваффақиятли ўзгарди',
        view: 'Кўриш',
        pricePh: 'нархи',
        qtyPh: 'миқдор',
        categoryPh: 'категория',
        confirmer: 'Тасдиқловчи',
        notConfirmed: 'Тасдиқланмаган',
        remarks: 'Изоҳлар',
        commentMin: 'Изоҳ камида 10 та белгидан иборат бўлиши керак!',
        commentForAccept: 'Қабул қилиш учун изоҳ',
        commentForReject: 'Рад этиш учун изоҳ',
        commentPh: 'Изоҳ киритинг...',
        phoneNumber: 'Рақами',
        returnedOk: 'Маҳсулот муваффақиятли омборга қайтарилди!',
        confirmAccept: 'Ҳақиқатан ҳам қабул қилишни хоҳлайсизми?',
        confirmReject: 'Ҳақиқатан ҳам рад этишни хоҳлайсизми?',
        addedOk: 'Буюртма қўшилди',
        addError: 'Қўшишда хатолик',
        updateError: 'Янгилашда хатолик',
        deletedOk: 'Ўчирилди',
        fetchError: 'Буюртмалар юкланмади',
        qtyMax: 'Миқдор 100 дан ошмаслиги керак!',
        returnOk: 'Товар муваффақиятли қайтарилди',
        returnError: 'Товарни қайтаришда хатолик',
        fetchWarehousesError: 'Омбор юкланмади',
        createOk: 'Буюртма муваффақиятли юборилди!',
        createError: 'Буюртма яратишда хатолик',
        send: 'Юбориш',
        qtyLabel: 'Миқдор (макс: {{qty}})',
        qtyRequired: 'Миқдорни киритинг',
        qtyExceed: 'Мавжуд: {{qty}} та',
        qtyPhInput: 'Миқдорни киритинг',
        commentOptional: 'Изоҳ киритинг (ихтиёрий)',
        pickProduct: 'Маҳсулот танланг',
        pickProductRequired: 'Илтимос, маҳсулот танланг!',
        qtyZero: 'Миқдор 0 бўлиши мумкин эмас!',
        qtyMaxAvailable: 'Энг кўп мавжуд: {{qty}} та',
        warehouseLabel: 'Омбор',
        fetchDataError: 'Маълумот юклашда хатолик',
        fetchCategoriesError: 'Категориялар юкланмади',
        requestDeleted: 'Буюртма ўчирилди',
        requestDeleteError: 'Буюртмани ўчиришда хатолик',
        comment: 'Изоҳ',
    },
    callCenter: {
        title: 'Қўнғироқлар маркази',
        new: 'Янги',
        planned: 'Режалаштирилган',
        completed: 'Бажарилган',
        canceled: 'Бекор қилинган',
        allTime: 'Барча вақт',
        searchName: 'Ф.И.Ш.',
        searchPhone: 'Телефон',
        date: 'Сана',
        schedule: 'Режалаштириш',
        scheduleCall: 'Қўнғироқни режалаштириш',
        newUser: 'Янги фойдаланувчи',
        all: 'Барчаси',
        source: 'Қаердан эшитди?',
        base: 'База',
        callTime: 'Қўнғироқ вақти',
        inBase: 'Базада',
        add: 'Қўшиш',
        pickDateTime: 'Сана ва вақтни танланг',
        fillNamePhone: 'Исм ва телефонни тўлдиринг',
        added: 'Фойдаланувчи қўшилди',
        addError: 'Қўшишда хатолик',
        loadError: 'Маълумот юкланмади',
        statsError: 'Статистика юкланмади',
        partnersError: 'Ҳамкорлар юкланмади',
        patientsError: 'Беморлар юкланмади',
        statusUpdated: 'Ҳолат янгиланди',
        statusError: 'Ҳолатни янгилашда хатолик',
        notFound: 'Ёзув топилмади',
        time: 'Вақт',
        sourcePlaceholder: 'Манбани танланг',
        userName: 'Фойдаланувчи исми',
        baseStatus: 'База ҳолати',
        birthAt: 'Туғилган сана',
        age: 'Ёши',
        minor: 'Вояга етмаган',
        adult: 'Вояга етган',
        guardians: 'Қариндошлар',
        guardian: 'Васий',
        relative: 'Қариндош',
        addGuardian: 'Қўшиш',
        noGuardians: 'Бириктирилган шахслар йўқ',
        guardianName: 'Ф.И.Ш.',
        guardianPhone: 'Телефон, масалан 998901112233',
        relationship: 'Қариндошлик',
        address: 'Манзил',
        notes: 'Изоҳ',
        guardianNameRequired: 'Исмни ёзинг',
        guardianPhoneRequired: 'Телефонни ёзинг',
        relationshipRequired: 'Қариндошликни ёзинг',
        guardianAdded: 'Шахс қўшилди',
        guardianUpdated: 'Маълумот янгиланди',
        guardianDeleted: 'Ёзув ўчирилди',
        guardianSaveError: 'Сақлаб бўлмади',
        guardianDeleteConfirm: 'Бу шахсни лиддан ўчириш?',
        forbidden: 'Рухсат йўқ',
    },
    doctorVisits: {
        title: 'Шифокор қабуллари',
        endVisit: 'Қабулни тугатиш',
        confirm: 'Тасдиқлаш',
        confirmEnd: 'Қабулни тугатишни хоҳлайсизми?',
        ended: 'Қабул муваффақиятли ёпилди',
        yesEnd: 'Ҳа, тугатиш',
        patientCard: 'Бемор картаси',
        patientName: 'Бемор',
        unknownDoctor: 'Номаълум шифокор',
        unknownPatient: 'Номаълум бемор',
        service: 'Хизмат',
        time: 'Вақт',
        queueNo: 'Навбат',
        allStatuses: 'Ҳаммаси',
        loadError: 'Қабулларни юклаб бўлмади',
        forbidden: 'Фақат шифокор учун',
        endError: 'Қабулни тугатиб бўлмади',
    },
    calendar: {
        search: 'Қидириш...',
        pickDate: 'Санани танланг',
        newVisit: 'Янги қабул',
        editVisit: 'Қабулни таҳрирлаш',
        viewVisit: 'Қабулни кўриш',
        welcome: 'Хуш келибсиз',
        today: 'Бугун',
        todayDoctors: 'Бугун · шифокорлар',
        calendar: 'Календар',
        doctors: 'Шифокорлар',
        day: 'Кун',
        week: 'Ҳафта',
        month: 'Ой',
        visits: 'қабул',
        withDoctor: 'шифокор билан',
        withoutDoctor: 'шифокорсиз',
        noRecords: 'Ёзув йўқ',
        unassigned: 'Шифокор белгиланмаган',
        dentist: 'Стоматолог',
        add: 'Қўшиш',
        past: 'Ўтган',
        planned: 'Режа',
        todayLabel: 'Бугун',
        prevMonth: 'Олдинги ой',
        nextMonth: 'Кейинги ой',
        prevWeek: 'Олдинги ҳафта',
        nextWeek: 'Кейинги ҳафта',
        prevDay: 'Олдинги кун',
        nextDay: 'Кейинги кун',
        layoutMonth: '1 · Ойлик календар',
        layoutDay: '2 · Шифокорлар (кун)',
        layoutWeek: '2 · Шифокорлар (ҳафта)',
        layoutMonthBoard: '2 · Шифокорлар (ой)',
        todayVisits: 'Бугунги қабуллар',
        date: 'Сана',
        fio: 'Ф.И.Ш.',
        phone: 'Телефон',
        patientOptional: 'Бемор (ихтиёрий)',
        doctorOptional: 'Шифокор (ихтиёрий)',
        description: 'Тавсиф',
        save: 'Сақлаш',
        update: 'Ўзгартириш',
        deleteEvent: 'Ёзувни ўчириш',
        searchPatient: 'Ф.И.Ш. бўйича қидириш...',
        pickDoctor: 'Шифокорни танланг',
        descriptionPh: 'Тавсиф...',
        todayReceptions: 'Бугунги қабуллар',
        bugungi: 'Бугунги қабуллар',
        updated: 'Ёзув янгиланди',
        updateError: 'Ёзувни янгилаб бўлмади',
        created: 'Ёзув яратилди',
        createError: 'Ёзув яратилмади',
        pickDateError: 'Санани танланг',
        fioRequired: 'Ф.И.Ш. киритинг',
        phoneRequired: 'Телефон рақамини киритинг',
        dateRequired: 'Санани танланг',
        noTodayVisits: 'Бугун қабуллар йўқ',
        noDoctorsList: 'Шифокорлар рўйхати йўқ',
        moreCount: '+{{count}} яна',
        layoutCalendar: '1 · Календар',
        layoutDoctors: '2 · Шифокорлар',
        registerPatient: 'Беморни рўйхатдан ўтказиш',
        phonePh: 'Телефон рақами:',
        dowMon: 'Ду',
        dowTue: 'Се',
        dowWed: 'Чо',
        dowThu: 'Па',
        dowFri: 'Жу',
        dowSat: 'Ша',
        dowSun: 'Як',
    },
    dental: {
        formula: 'Тиш формуласи',
        upper: 'Юқори',
        lower: 'Пастки',
        all: 'Ҳаммаси',
        clear: 'Тозалаш',
        unselected: 'Танланмаган',
        selected: 'Танланган',
        hasRemark: 'Изоҳ мавжуд',
        selectedCount: 'Танланган',
        save: 'Сақлаш',
        jawUpper: 'юқори жағ',
        jawLower: 'пастки жағ',
        tooth: 'Тиш {{id}}',
        remarkPh: 'Изоҳ киритинг',
        remarksTitle: 'Танланган тишлар бўйича изоҳлар',
        problems: 'Муаммолар',
        xrays: 'Рентгенлар',
        noXrays: 'Рентген суратлар йўқ',
        jawAreas: 'Жағ соҳалари',
        pickJaw: 'Жағ соҳасини танланг',
        pickProblem: 'Муаммони танланг',
        searchProblems: 'Жағ ва муаммолар бўйича қидириш',
        jawLeft: 'Чап томон',
        jawRight: 'Ўнг томон',
        malocclusion: 'Нотўғри тишлаш',
        crossbite: 'Кесишган тишлаш',
        diastema: 'Диастема',
        crowding: 'Тиш қийшиқлиги',
        malposition: 'Тишнинг нотўғри жойлашуви',
        teethSaved: 'Тиш маълумотлари муваффақиятли юборилди',
    },
    patientCard: {
        title: 'Бемор картаси',
        hideProfile: 'Профилни яшириш',
        showProfile: 'Профилни кўрсатиш',
        visitNo: 'Қабул №',
        startVisit: 'Қабулни бошлаш',
        starting: 'Бошланмоқда...',
        endVisit: 'Қабулни тугатиш',
        ending: 'Тугатиляпти...',
        createVisit: 'Қабул яратиш',
        addEpidem: 'Эпиданамнез қўшиш',
        notAvailable: 'Мавжуд эмас',
        birthDate: 'Туғилган сана',
        phone: 'Телефон',
        province: 'Вилоят',
        district: 'Туман',
        partner: 'Ҳамкор',
        address: 'Манзил',
        profession: 'Касби',
        gender: 'Жинси',
        visits: 'Қабуллар',
        noteText: 'Изоҳ матни',
        male: 'Эркак',
        female: 'Аёл',
        addToVisit: 'Қабулга қўшиш',
        pickService: 'Хизматни танланг',
        discount: 'Чегирма',
        pickDiscount: 'Чегирмани танланг',
        visitAdded: 'Қабул қўшилди',
        noDoctors: 'Мавжуд шифокорлар йўқ',
        newVisitSubmit: 'Янги қабул қўшиш',
        readyTitle: 'Бемор қабул бошланишга тайёр',
        readyDesc: 'Бемор хизмат учун пул тўлади, учрашувни бошлаш мумкин',
        addedTitle: 'Янги қабул қўшилди',
        addedDesc: 'Қабул қўшилган, аммо бемор ҳали пул тўламаган',
        notAddedTitle: 'Бемор қабулга қўшилмаган',
        notAddedDesc: 'Даволашни бошлаш учун беморни қабулга қўшинг',
        tabNewVisit: 'Янги қабул',
        tabHistory: 'Ташриф ва қўнғироқлар',
        tabViewVisits: 'Қабулларни кўриш',
        visitsTitle: 'Қабуллар',
        visitAt: 'Ташриф: {{date}}',
        visitNoN: 'Ташриф №{{id}}',
        dateAt: 'Сана: {{date}}',
        revisitDate: 'Қайта қабул санаси',
        onDispensary: 'Диспансер ҳисобига олинганми',
        viewAll: 'Барча маълумотларини кўриш',
        fileNotUploaded: 'Файл юкланмаган',
        noInfo: 'Маълумот йўқ',
        visitDate: 'Ташриф санаси',
        paymentType: 'Тўлов тури',
        loadingData: 'Маълумот юкланмоқда...',
        complaint: 'Шикоят',
        illness: 'Хасталик',
        diagnosis: 'Ташхис',
        illHistory: 'Касаллик тарихи',
        anamnez: 'Анамнез {{n}}',
        treatment: 'Даволаш',
        oralView: 'Оғиз бўшлиғи кўриниши.',
        teethState: 'Тишларнинг ҳолати:',
        totalForms: 'Жами {{total}} та форма',
        workAddress: 'Иш жойи',
        sentBy: 'Ким юборди',
        epidemAdded: 'Эпидемиологик анамнез қўшилди',
        added: 'Қўшилди',
        noDistrict: 'Туман маълумоти йўқ',
        noPartner: 'Ҳамкор маълумоти йўқ',
        colTitle: 'Номланиши',
        colDesc: 'Тавсиф',
        colActive: 'Фаол',
        cityDistrict: 'Шаҳар/туман',
        filesTypes: 'Рентген, ҳужжат, расм ...',
        createVisitAction: 'Қабулни яратиш',
        patientFio: 'Бемор Ф.И.Ш.',
        condExtracted: 'Тортилган тиш',
        condRoot: 'Томир қолган',
        condCaries: 'Кариес',
        condPulpitis: 'Пульпит',
        condPeriodontitis: 'Периодонтит',
        condParadontosis: 'Пародонтоз',
        condMobility: 'Қимирлаш',
        condFilling: 'Қоплама',
        condArtificial: 'Сунъий тиш',
    },
    notfound: {
        code: '404',
        title: 'Саҳифа топилмади',
        text: 'Кечирасиз, бу саҳифа мавжуд эмас. Бош саҳифага қайтишингиз мумкин.',
        home: 'Бош саҳифа',
    },
    roles: {
        title: 'Роллар',
        create: 'Рол қўшиш',
        select: 'Ролни танланг',
    },
    users: {
        title: 'Фойдаланувчилар',
        add: 'Қўшиш',
        edit: 'Таҳрирлаш',
        delete: 'Ўчириш',
        create: 'Янги фойдаланувчи',
        editTitle: 'Фойдаланувчини таҳрирлаш',
        role: 'Рол',
        phonePlaceholder: 'Телефон рақами',
        created: 'Фойдаланувчи яратилди',
        updated: 'Фойдаланувчи янгиланди',
        deleted: 'Фойдаланувчи ўчирилди',
        passwordMismatch: 'Пароллар мос эмас',
        addTechnician: 'Техник қўшиш',
        technicianCreated: 'Техник яратилди',
    },
    form43: {
        part1: 'I қисм',
        part2: 'II қисм',
        part3: 'III қисм',
        part4: 'IV қисм',
        headerLeft: 'ЎЗБЕКИСТОН РЕСПУБЛИКАСИ СОҒЛИҚНИ САҚЛАШ ВАЗИРЛИГИ',
        headerRight: 'Соғлиқни сақлаш вазирлигининг 043/у шаклидаги тиббий ҳужжати',
        title: 'СТОМАТОЛОГИЯ БЕМОРИНИНГ ТИББИЙ ВАРАҚАСИ',
        fullName: 'Исми шарифи',
        birthYear: 'Туғилган йили',
        address: 'Турар жойи',
        job: 'Иш жойи, касби',
        diagnosis: 'Ташхис',
        complaints: 'Шикояти',
        childhoodHistory: 'Болаликда ва кейинги пайтда қандай касал бўлган',
        childhoodHistoryPh: 'Касаллик тарихи',
        currentHistory: 'Ҳозирги касалликнинг бошланиш тарихи',
        currentHistoryPh: 'Ҳозирги касаллик тарихи',
        epidemQ1: 'Эпид анамнез: 1) Инфекцион беморлар билан контактда бўлганми?',
        epidemQ2: '2) 1 ҳафта – 2 ой мобайнида турар жойидан четга чиққанми?',
        epidemQ2Ph: 'Турар жойидан четга чиққанми?',
        epidemQ3: '3) Қайси инфекцион касалликларни бошидан кечирган?',
        epidemQ4: '4) Стационар ва амбулатор даволанганми?',
        epidemQ5: '5) Парентерал муолажалар олганми?',
        epidemQ6: '6) Маиший хизматлардан фойдаланганми?',
        allergy: 'Аллергоанамнез: турли дори ва овқат маҳсулотларига аллергия бор?',
        allergyPh: 'Аллергия бор, йўқ?',
        clinicalDiagnosis: 'Анамнез ва клиник кўрсатмаларга кўра аниқлашга мўлжалланган ташхис (диагноз)',
        appearance: 'Ташқи кўриниш',
        teethCondition: 'Тишларнинг ҳолати',
        condExtracted: 'Тортилган тиш – O',
        condRoot: 'Томир қолган – R',
        condCaries: 'Кариес – C',
        condPulpitis: 'Пульпит – P',
        condPeriodontitis: 'Периодонтит – A',
        condMobility: 'Қимирлаш – I-III',
        condFilling: 'Қоплама – K',
        condArtificial: 'Сунъий тиш – I',
        treatment: 'Даволаш',
    },
    queues: {
        title: 'Янги навбат',
        select: 'Бемор ва шифокорни танланг',
        visitTime: 'Қабул вақти',
        busy: 'банд',
        noDate: 'Сана йўқ',
        notStarted: 'Қабул бошланмаган',
        doctorsError: 'Шифокорлар юкланмади',
        created: 'Бемор {{patientId}} ва шифокор {{doctorId}} учун қабул яратилди',
        confirmVisit: 'Қабулни тасдиқлаш',
    },
    followupsPage: {
        title: 'Қайта қўнғироқлар',
        dueHint: 'Муддати келган беморлар: {{count}}',
        dueDate: 'Қўнғироқ муддати',
        enterResult: 'Натижа киритиш',
        loadError: 'Рўйхат юкланмади',
        saved: 'Натижа сақланди',
        alreadyClosed: 'Эслатма аллақачон ёпилган',
        saveError: 'Сақлашда хатолик',
        total: 'Жами: {{total}}',
        remarkOptional: 'Изоҳ (ихтиёрий)',
        remarkPh: 'Изоҳ...',
        noAnswer: 'Жавоб бермади',
        contacted: 'Боғланилди',
        willVisit: 'Келишини айтди',
    },
    unauthorized: {
        title: 'Рухсат йўқ',
        text: 'Бу саҳифани кўриш учун ҳуқуқингиз йўқ.',
        home: 'Бош саҳифа',
    },
    admissionPrint: {
        title: 'Бемор маълумоти',
        print: 'Принтердан чиқариш',
        diseases: 'Касалликларнинг халқаро таснифи',
        conclusion: 'Шифокор хулосаси',
        noConclusion: 'Хулоса йўқ...',
        revisits: 'Қайта қабуллар',
        noRevisits: 'Қайта ташрифлар йўқ',
        dispensary: 'Диспансер рўйхатлари',
        dispensaryDate: 'Диспансер санаси',
        noDispensary: 'Диспансер ёзувлари йўқ',
        files: 'Юкланган файллар',
        notFound: 'Бемор маълумоти топилмади',
        photo: 'Сурат',
        code: 'Код',
        mkb10: 'ХКТ-10',
        conclusionLabel: 'Хулоса',
        loading: 'Юкланмоқда',
        filesTypes: 'Рентген, ҳужжат, расм ...',
        loadError: 'Бемор маълумоти олинмади',
    },
    visit: {
        conclusion: 'Шифокор хулосаси',
        dragFiles: 'Файл(лар)ни бу ерга ташланг ёки',
        clickFiles: 'файл(лар)ни танлаш учун босинг',
        saveSend: 'Сақлаш ва юбориш',
        loadingTemplates: 'Шаблонлар юкланмоқда...',
        pickTemplate: 'Шаблонни танланг',
        addTemplate: 'Шаблон қўшиш',
        templateName: 'Шаблон номини киритинг',
        sendTemplate: 'Шаблонни юбориш',
        send: 'Юбориш',
        revisit: 'Қайта қабул',
        addRevisit: 'Қайта қабулга қўшиш',
        procedure: 'Протседурага юбориш',
        addDispensary: 'Диспансер рўйхатига қўшиш',
        filesSent: 'Расмлар юборилди',
        filesError: 'Файлларни юклашда хатолик юз берди',
        commentSent: 'Изоҳ юборилди',
        commentError: 'Изоҳ юборишда хатолик',
        templateSent: 'Шаблон юборилди',
        templateError: 'Шаблон юборишда хатолик',
        mkbAdded: 'ХКТ қўшилди',
        pickDate: 'Илтимос, кунни танланг',
        revisitSet: 'Қайта қабул: {{date}}',
        dispensarySet: 'Диспансер рўйхати: {{date}}',
        colName: 'Номланиши',
    },
    history: {
        loadFailed: 'Тарих юкланмади',
        summary: 'Умумий маълумот',
        lastVisit: 'Охирги ташриф',
        nextVisit: 'Кейинги қабул',
        nextContact: 'Кейинги қайта боғланиш',
        timeNotSet: 'Вақти белгиланмаган',
        visitsHistory: 'Ташрифлар тарихи',
        noVisits: 'Ташрифлар йўқ',
        callsHistory: 'Қўнғироқлар тарихи (охирги 10)',
        noCalls: 'Қўнғироқ тарихи йўқ',
        registeredBy: 'Рўйхатга олган',
        services: 'Хизматлар',
        noAnswer: 'Жавоб бермади',
        contacted: 'Боғланилди',
        willVisit: 'Келишини айтди',
    },
    techRequest: {
        catalogTitle: 'Техник объектлари',
        catalogNew: 'Янги объект',
        catalogEdit: 'Объектни таҳрирлаш',
        requestsTitle: 'Техникка буюртмалар',
        requestsTitleDoctor: 'Техникка буюртмаларим',
        requestsTitleTech: 'Буюртмалар',
        newOrder: 'Янги буюртма',
        object: 'Объект',
        parameters: 'Параметрлар',
        addParameter: 'Параметр қўшиш',
        options: 'Вариантлар',
        requiredParam: 'Мажбурий',
        objectPrice: 'Объект нархи',
        paramPrice: 'Параметр нархи',
        estimatedTotal: 'Дастлабки сумма',
        finalPrice: 'Якуний нарх',
        parametersTotal: 'Параметрлар жами',
        description: 'Қўшимча талаблар',
        descriptionPh: 'Қўшимча талабларни ёзинг',
        actionNote: 'Изоҳ',
        actionNotePh: 'Амал изоҳи (ихтиёрий)',
        technician: 'Техник',
        orderedBy: 'Буюртма берган шифокор',
        selectObject: 'Объектни танланг',
        selectTechnician: 'Техникни танланг',
        selectPatient: 'Беморни танланг',
        preview: 'Ҳисоб',
        snapshotNote: 'Нархлар буюртма юборилган пайтдаги қийматда сақланади.',
        pending: 'Янги',
        inProgress: 'Жараёнда',
        completed: 'Бажарилган',
        returned: 'Қайтарилган',
        start: 'Ишни бошлаш',
        complete: 'Бажарилган деб белгилаш',
        returnWork: 'Қайта ишлашга қайтариш',
        returnReason: 'Қайтариш сабаби',
        lastReturn: 'Охирги қайтариш',
        changePrice: 'Нархни ўзгартириш',
        newPrice: 'Янги нарх',
        priceNote: 'Нарх изоҳи',
        history: 'Тарих',
        historyEmpty: 'Тарих йўқ',
        statusChanged: 'Ҳолат ўзгариши',
        priceChanged: 'Нарх ўзгариши',
        inactive: 'Нофаол',
        active: 'Фаол',
        deactivate: 'Танловдан яшириш',
        activate: 'Фаоллаштириш',
        deleteConfirm: 'Объект каталогдан олиб ташлансинми? Эски буюртмалар сақланади.',
        loadError: 'Маълумотларни юклаб бўлмади',
        saveError: 'Сақлаб бўлмади',
        forbidden: 'Рухсат йўқ',
        conflict: 'Бу амал ҳозир мумкин эмас',
        notFound: 'Ёзув топилмади',
        createdOk: 'Буюртма юборилди',
        savedOk: 'Сақланди',
        deletedOk: 'Ўчирилди',
        startedOk: 'Иш бошланди',
        completedOk: 'Бажарилган деб белгиланди',
        returnedOk: 'Буюртма қайтарилди',
        priceUpdated: 'Нарх янгиланди',
        noTechnicians: 'Техниклар йўқ',
        noObjects: 'Фаол объектлар йўқ',
        requiredParamsMissing: 'Мажбурий параметрларни тўлдиринг',
        descriptionRequired: 'Қўшимча талабларни ёзинг',
        returnRequired: 'Қайтариш сабабини ёзинг',
        optionsRequired: 'Камида битта вариант қўшинг',
        paramName: 'Параметр номи',
        from: 'Олдин',
        to: 'Кейин',
        tooth: 'Тиш',
        toothOptional: 'ихтиёрий',
        adultTeeth: 'Доимий',
        childTeeth: 'Сут тишлари',
    },
    patientActivity: {
        title: 'Мижозлар фаоллиги',
        search: 'Исм, телефон ёки код',
        overdue: '6 ойдан бери келмаган',
        recent: 'Сўнгги 6 ойда келган',
        never_visited: 'Ҳали келмаган',
        visited: 'Барча келганлар',
        overdueHint: 'Охирги ташриф чегарадан олдин',
        recentHint: 'Охирги ташриф чегарадан кейин',
        neverHint: 'Ёпилган қабул йўқ',
        visitedHint: 'Камида битта ташриф',
        lastVisit: 'Охирги ташриф',
        visitsCount: 'Қабуллар',
        createdAt: 'Яратилган',
        neverVisitedLabel: 'Ҳали келмаган',
        history: 'Тарих',
        cutoffNote: 'Бугун {{today}} · 6 ойлик чегара {{cutoff}}',
        loadError: 'Рўйхат юкланмади',
        forbidden: 'Рухсат йўқ',
    },
    additionalServices: {
        title: 'Қўшимча хизматлар',
        add: 'Қўшиш',
        create: 'Янги қўшимча хизмат',
        edit: 'Хизматни таҳрирлаш',
        search: 'Ном бўйича қидириш',
        name: 'Номи',
        price: 'Нархи',
        description: 'Изоҳ',
        prefix: 'Префикс',
        time: 'Дақиқа',
        author: 'Муаллиф',
        createdBy: 'Яратган',
        performedBy: 'Ўзгартирган',
        history: 'Тарих',
        includeDeleted: 'Архивни кўрсатиш',
        active: 'Фаол',
        archived: 'Архив',
        created: 'Хизмат яратилди',
        updated: 'Хизмат янгиланди',
        deleted: 'Хизмат ўчирилди',
        deleteConfirm: 'Хизматни ўчириш? Тарих сақланади.',
        nameRequired: 'Номини ёзинг',
        priceRequired: 'Нархни ёзинг',
        saveError: 'Сақлаб бўлмади',
        forbidden: 'Фақат админ учун',
        notFound: 'Хизмат топилмади',
        action: 'Амал',
        changes: 'Ўзгаришлар',
        action_created: 'Яратилди',
        action_updated: 'Ўзгартирилди',
        action_deleted: 'Ўчирилди',
        field_name: 'Номи',
        field_price: 'Нархи',
        field_description: 'Изоҳ',
        field_prefix: 'Префикс',
        field_time: 'Дақиқа',
        field_type: 'Тури',
        field_deleted_at: 'Ўчирилган',
    },
};

export default uzCyrl;
